import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CRow,
  CFormLabel,
  CModalHeader,
} from '@coreui/react'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import useAxios from 'axios-hooks'
import { CUSTOM_PAGES_API } from 'src/views/utils/urls'
import { createPageUrl, raiseToast } from 'src/views/utils/helper'
import moment from 'moment'
import '../artistModal/artistModal.scss'
import CardListComponent from 'src/views/container/customStaticPages/cardListComponent'
import { isEmpty } from 'lodash'

const PageModal = () => {
  const { setLoader, loader, pageModalProps, accountObj, setPageModalProps } =
    useContext(AppContext)
  const { type, mappedPageId, selectCallback } = pageModalProps
  const [pagesData, setPagesData] = useState([])
  const [selectedPageId, setSelectedPageId] = useState(
    type === 'single' ? `${mappedPageId}` : [...mappedPageId],
  )

  const [{ data: pagesList, loading: pagesListLoading }] = useAxios({
    url: CUSTOM_PAGES_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(pagesListLoading)
  }, [pagesListLoading])

  useEffect(() => {
    if (pagesList && pagesList.success) {
      setPagesData(pagesList.data)
    }
  }, [pagesList])

  const handlePageSelect = (info) => {
    if (type === 'single') {
      info._id === selectedPageId ? setSelectedPageId('') : setSelectedPageId(info._id)
      return
    }
    let temp = selectedPageId
    let pageIndex = selectedPageId.findIndex((e) => e === info._id)
    if (pageIndex > -1) {
      temp = selectedPageId.filter((e) => e !== info._id)
    } else {
      temp.push(info._id)
    }

    setSelectedPageId([...temp])
  }

  const handleSelect = () => {
    if (isEmpty(selectedPageId)) {
      raiseToast('error', 'Please Select a Page.')
      return
    }
    if (type === 'single') {
      const pageObj = pagesData.find((info) => info._id === selectedPageId)
      if (selectedPageId && pageObj) {
        selectCallback(pageObj)
        setPageModalProps({})
      }
      return
    }

    let pageArr = []

    for (let i = 0; i < selectedPageId.length; i++) {
      const id = selectedPageId[i]
      const pageObj = pagesData.find((info) => info._id === id)
      if (pageObj) {
        pageArr.push(pageObj)
      }
    }
    selectCallback(pageArr)
    setPageModalProps({})
  }

  const handleActiveClasses = (info) => {
    let flag = false
    if (type === 'single') {
      flag = info._id === selectedPageId
    } else {
      flag = selectedPageId.findIndex((e) => e === info._id) > -1
    }

    return flag
  }

  return (
    <CModal scrollable size="xl" visible={true} alignment="center" className="content-modal-full">
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader>
        <CRow className="mx-4 mt-3">
          <p style={{ fontSize: '20px', fontWeight: 'bold' }} className="h4">
            Page List
          </p>
          <CFormLabel style={{ fontSize: '13px' }}>
            Following are the Custom Pages which are already in your CMS.
          </CFormLabel>
        </CRow>
      </CModalHeader>
      <CModalBody style={{ padding: '4px', height: '35rem' }} className="scrollbar-class mx-5">
        <div
          className="d-flex justify-content-center align-items-center bg-black text-white rounded-1"
          style={{
            fontSize: 'max(1vw,14px)',
            gap: '0 2.2%',
            padding: '2px .6vw',
            top: '0',
            left: '50%',
            transform: 'translateX(0%)',
            right: '0',
            zIndex: '1',
            width: '100%',
            position: 'sticky',
          }}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ width: '100%', fontWeight: '600' }}
          >
            <p style={{ marginBlockEnd: '0', width: '40%' }}>Page Title</p>
            <p style={{ marginBlockEnd: '0', width: '40%' }}>Page URL</p>
            <p style={{ marginBlockEnd: '0', width: '12%' }}>Last Modified</p>
            <div style={{ width: '5%' }}></div>
          </div>
        </div>
        <div className="pt-3">
          {pagesData.map((info) => (
            <CardListComponent
              key={info._id}
              id={info._id}
              pageTitle={info?.name}
              pageUrl={createPageUrl(
                accountObj?.domain_name,
                info?.page_url,
                `/${info.type.toLowerCase()}`,
              )}
              mappedToTemplate={info?.mappedToTemplate}
              lastModified={moment(info?.modified_date).format('DD MMMM YYYY')}
              cardStyle={{ marginBottom: '.84vw', aspectRatio: '1388/71' }}
              hideOptions={true}
              onClick={() => handlePageSelect(info)}
              activeFlag={handleActiveClasses(info)}
            />
          ))}
        </div>
      </CModalBody>
      <CModalFooter className="px-5">
        <CButton
          style={{ color: 'black', border: '1px solid #bdbdbd', fontSize: '1.1rem' }}
          className="mx-4 bg-white rounded-1 btn-focus-none"
          onClick={() => setPageModalProps({})}
        >
          Cancel
        </CButton>
        <CButton
          style={{ fontSize: '1.1rem' }}
          className=" bg-black rounded-1 btn-focus-none"
          onClick={handleSelect}
        >
          Select
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default PageModal
